export const TOKEN = 'ApiToken';
export function getToken() {
    return localStorage.getItem(TOKEN)
}
export function setToken(tokenValue) {
    localStorage.setItem(TOKEN, tokenValue);
}
